<template>
  <div class="first-book-analysis-panel" v-loading="loading">
    <el-alert
      v-if="error"
      :title="error"
      type="warning"
      :closable="false"
      show-icon
      class="panel-alert"
    />

    <AnalysisDataStatusPanel
      :payload="payload"
      :loading="loading"
      title="第一本账分析数据状态"
      subtitle="按当前正式区与临时区股票判断分析是否可用；页面只展示业务状态，内部数据维护细节由后台处理。"
      :show-items="true"
      :show-name="true"
      :show-zone="true"
      @refresh="refreshData"
    />

    <div class="scope-note" v-if="scopeReady">
      <span>当前第一本账：正式区 {{ scope.formal_count || 0 }} 只</span>
      <span>临时区 {{ scope.temp_count || 0 }} 只</span>
      <span>合计 {{ scope.stock_total_count || 0 }} 只</span>
    </div>
  </div>
</template>

<script>
import AnalysisDataStatusPanel from '@/components/AnalysisDataStatusPanel.vue'
import { firstBookP0Api, firstBookErrorMessage } from '@/api/firstBookP0'

export default {
  name: 'FirstBookHistoryCoveragePanel',
  components: { AnalysisDataStatusPanel },
  data() {
    return {
      loading: false,
      error: '',
      payload: {}
    }
  },
  computed: {
    scope() { return (this.payload || {}).scope || {} },
    scopeReady() { return Boolean(this.scope && Object.keys(this.scope).length) }
  },
  created() { this.refreshData() },
  methods: {
    async refreshData() {
      this.loading = true
      this.error = ''
      try {
        this.payload = await firstBookP0Api.getAnalysisDataStatus()
        this.$emit('scope-updated', this.scopeReady ? { ...this.scope } : null)
      } catch (error) {
        this.payload = {}
        this.$emit('scope-updated', null)
        this.error = firstBookErrorMessage(error, '读取第一本账分析数据状态失败')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.first-book-analysis-panel { margin-bottom: 16px; }
.panel-alert { margin-bottom: 12px; }
.scope-note { display: flex; flex-wrap: wrap; gap: 16px; margin-top: 10px; padding: 10px 12px; border-radius: 10px; background: #f6f8fb; color: #64748b; font-size: 12px; }
</style>
